module.exports = __webpack_public_path__ + "assets/img/26_894_big.09740f79.jpg";